import { useState } from 'react';
import { FileTrigger } from 'react-aria-components';
import { GreenCircleCheckmark } from '../../svg/GreenCircleCheckmark';
import { Button, Icon } from '@platform/components';

export const FileUploadWithButton = ({
  onFileUpload,
  buttonText = 'Upload file',
  acceptedFileTypes,
}: {
  onFileUpload: (file: File) => void;
  buttonText?: string;
  acceptedFileTypes?: string[] | undefined;
}) => {
  const [fileUploaded, setFileUploaded] = useState(false);

  return (
    <FileTrigger
      acceptedFileTypes={acceptedFileTypes}
      onSelect={(e) => {
        const files = e ? Array.from(e) : [];
        if (files.length > 0) {
          onFileUpload(files[0]);
        }
        setFileUploaded(true);
      }}
    >
      <Button additionalClassnames='p-4 h-[44px] w-full' variant='secondary-gray' size='md'>
        <div className='w-full h-full flex flex-row gap-1.5 items-center justify-center text-gray-600 font-semibold'>
          {fileUploaded && <GreenCircleCheckmark size={18} />}
          {!fileUploaded && <Icon type='upload-01' size='18' />}
          {fileUploaded ? 'Upload complete' : buttonText}
        </div>
      </Button>
    </FileTrigger>
  );
};
